import { get, orderBy } from "lodash";

export const buildStrengthData = strengthsData =>
  strengthsData.map(strength => {
    const strengthJSON = JSON.parse(strength.value);
    return strengthJSON.strengths.map(strengthElement => ({
      title: strengthElement,
      color: strengthJSON.color,
      category: strengthJSON.category,
      id: strengthElement,
      display: `#${strengthElement}`
    }));
  });

export const buildUserData = usersData =>
  orderBy(usersData, "firstName").map(user => {
    return {
      title: `${get(user, "firstName", "")} ${get(user, "lastName", "")}`,
      color: "#e7e5e5",
      // category: strengthJSON.category,
      id: user?.id, //`${get(user, "firstName", "")} ${get(user, "lastName", "")}`,
      display: `@${get(user, "firstName", "")} ${get(user, "lastName", "")}`
    };
  });

export const taggedNameFormat = (data, isEdit) => {
  if (get(data, "user.firstName")) {
    return `${isEdit ? "@" : ""}${get(data, "user.firstName", "")} ${get(
      data,
      "user.lastName"
    )}`;
  } else {
    return get(data, "name", "");
  }
};

export const getBase64File = (file, setData) => {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    setData && setData(reader.result);
  };
  reader.onerror = function (error) {
    console.log("Error: ", error);
  };
};
